import { gql } from "@apollo/client";

export default gql`
  mutation savePersonalTranscriptSyncCredentialMutation(
    $provider: PersonalTranscriptSyncCredentialProviderEnum!
    $apiKey: String!
  ) {
    savePersonalTranscriptSyncCredential(provider: $provider, apiKey: $apiKey) {
      user {
        id
        hasGranolaPersonalApiToken
        hasFirefliesPersonalApiToken
      }
    }
  }
`;
